/**
 * @generated SignedSource<<3f3c446ac18e2e69510feb241ee65f71>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type Role = "ADMIN" | "APPROVER" | "EDITOR" | "%future added value";
export type AdminListUsersRequest = {
  accountId?: string | null;
  includeArchived?: boolean | null;
  pageNumber?: number | null;
  pageSize?: number | null;
  search?: string | null;
};
export type UsersTabQuery$variables = {
  input: AdminListUsersRequest;
};
export type UsersTabQuery$data = {
  readonly adminListUsers: {
    readonly count: number;
    readonly data: ReadonlyArray<{
      readonly account: {
        readonly id: string;
        readonly name: string;
      } | null;
      readonly accountRoles: ReadonlyArray<{
        readonly role: Role;
      }>;
      readonly createdAt: any;
      readonly email: string | null;
      readonly featureFlagIds: ReadonlyArray<string>;
      readonly firstName: string | null;
      readonly fullName: string | null;
      readonly id: string;
      readonly lastName: string | null;
      readonly superuser: boolean;
      readonly userBrands: ReadonlyArray<{
        readonly brand: {
          readonly id: string;
          readonly name: string;
        };
        readonly id: string;
        readonly roles: ReadonlyArray<{
          readonly role: Role;
        }>;
      }>;
    }>;
  };
};
export type UsersTabQuery = {
  response: UsersTabQuery$data;
  variables: UsersTabQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  (v1/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
],
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "role",
    "storageKey": null
  }
],
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AdminUserList",
    "kind": "LinkedField",
    "name": "adminListUsers",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "count",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminUser",
        "kind": "LinkedField",
        "name": "data",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fullName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "superuser",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "featureFlagIds",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AdminAccountRef",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserRole",
            "kind": "LinkedField",
            "name": "accountRoles",
            "plural": true,
            "selections": (v3/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AdminUserBrand",
            "kind": "LinkedField",
            "name": "userBrands",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AdminBrandRef",
                "kind": "LinkedField",
                "name": "brand",
                "plural": false,
                "selections": (v2/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserRole",
                "kind": "LinkedField",
                "name": "roles",
                "plural": true,
                "selections": (v3/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UsersTabQuery",
    "selections": (v4/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UsersTabQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "7eed8cf36b6308743f8e5af4a7756d3b",
    "id": null,
    "metadata": {},
    "name": "UsersTabQuery",
    "operationKind": "query",
    "text": "query UsersTabQuery(\n  $input: AdminListUsersRequest!\n) {\n  adminListUsers(input: $input) {\n    count\n    data {\n      id\n      email\n      fullName\n      firstName\n      lastName\n      superuser\n      createdAt\n      featureFlagIds\n      account {\n        id\n        name\n      }\n      accountRoles {\n        role\n      }\n      userBrands {\n        id\n        brand {\n          id\n          name\n        }\n        roles {\n          role\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9a8a17c104d9e01df87c87e3a99fd060";

export default node;
